import qs from 'qs';
import client from './client';

const adminBudgetUrl = '/api/v1/settlement/expense';
const budgetUrl = '/api/v1/settlement/budget';

// 4대 보험 보험요율
export const getAllMajorInsurance = ({ year }) => {
  return client.get(`${adminBudgetUrl}/allInsure/info/${year}`);
};

export const saveAllMajorInsurance = (dataToSubmit) => {
  return client.post(`${adminBudgetUrl}/allInsure/info`, dataToSubmit);
};

/**
 * 4대 보험 보험요율을 업데이트합니다.
 * @param {Object} dataToSubmit 4대 보험 보험요율
 * @return {Promise}
 */
export const updateAllMajorInsurance = (dataToSubmit) => {
  return client.put(
    `${adminBudgetUrl}/allInsure/info/${dataToSubmit.year}`,
    dataToSubmit,
  );
};

//개인별 급여 가져오기
export const getIndividualSalary = ({ year, usrUuid }) => {
  // const queryString = qs.stringify(searchData);

  return client.get(`${adminBudgetUrl}/personal/info/${year}/${usrUuid}`);
};

export const addIndividualSalary = (dataToSubmit) => {
  return client.post(`${adminBudgetUrl}/personal/info`, dataToSubmit);
};

// 국민연금
export const addIndividualNP = (dataToSubmit) => {
  return client.post(`${adminBudgetUrl}/personal/np/info`, dataToSubmit);
};

// 건강보험
export const addIndividualHI = (dataToSubmit) => {
  return client.post(`${adminBudgetUrl}/personal/hi/info`, dataToSubmit);
};

// 고용보험
export const addIndividualEI = (dataToSubmit) => {
  return client.post(`${adminBudgetUrl}/personal/ei/info`, dataToSubmit);
};

// 산재
export const addIndividualAI = (dataToSubmit) => {
  return client.post(`${adminBudgetUrl}/personal/ai/info`, dataToSubmit);
};

// 개인별 급여 엑셀 업로드
export const uploadExlByIndividualSalary = (formData) => {
  return client.post(`${adminBudgetUrl}/personal/info/upload`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};
// 개인별 급여 엑셀 다운로드
export const downloadExlByIndividualSalary = ({ year }) => {
  return client.get(`${adminBudgetUrl}/personal/info/${year}/download `, {
    responseType: 'arraybuffer',
  });
};

// export const editIndividualSalary = (dataToSubmit) => {
//   return client.put(
//     `${BudgetUrl}/salary/info/${dataToSubmit.scUuid}`,
//     dataToSubmit,
//   );
// };

// //판매관리비 삭제
// export const deleteIndividualSalary = (id) =>
//   client.delete(`${BudgetUrl}/salary/info/${id}`);

// 개인별 직접비 예산 가져오기
export const getIndividualDirectCost = ({ year, usrUuid }) => {
  return client.get(`${budgetUrl}/personal/info/${year}/${usrUuid}`);
};

export const saveIndividualDirectCost = (dataToSubmit) => {
  return client.post(`${budgetUrl}/personal/info`, dataToSubmit);
};

export const deleteIndividualDirectCost = (delData) => {
  return client.delete(`${budgetUrl}/personal/info/${delData?.smallId}`);
};

// 개인별 직접비 예산 업로드
export const uploadExlByIndividualDirectCost = (formData) => {
  return client.post(`${budgetUrl}/personal/info/upload`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

// 개인별 직접비 예산 다운로드
export const downloadExlByIndividualDirectCost = ({ year }) => {
  return client.get(`${budgetUrl}/personal/info/${year}/download `, {
    responseType: 'arraybuffer',
  });
};

// 전체 간접비 가져오기
export const getTotalInderectCost = ({ year }) => {
  return client.get(`${budgetUrl}/indirect/info/${year}`);
};

export const saveTotalInderectCost = (dataToSubmit) => {
  return client.post(`${budgetUrl}/indirect/info`, dataToSubmit);
};

export const deleteTotalInderectCost = (delData) => {
  return client.delete(`${budgetUrl}/indirect/info/${delData?.smallId}`);
};

// 전체 간접비 관리
export const uploadExlByTotalInderectCost = (formData) => {
  return client.post(`${budgetUrl}/indirect/info/upload`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

export const downloadExlByTotalInderectCost = ({ year }) => {
  return client.get(`${budgetUrl}/indirect/info/${year}/download `, {
    responseType: 'arraybuffer',
  });
};

// 본부 예산 관리
export const getHqBudget = ({ year, dptUuid }) => {
  return client.get(`${budgetUrl}/divison/info/${dptUuid}/${year}`);
};

export const saveHqBudget = (dataToSubmit) => {
  return client.post(`${budgetUrl}/divison/info`, dataToSubmit);
};

export const deleteHqBudget = (delData) => {
  return client.delete(`${budgetUrl}/divison/info/${delData?.smallId}`);
};

export const uploadExlByHqBudget = (formData) => {
  return client.post(`${budgetUrl}/divison/info/upload`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

export const downloadExlByHqBudget = ({ year }) => {
  return client.get(`${budgetUrl}/divison/info/${year}/download `, {
    responseType: 'arraybuffer',
  });
};

// 팀별 예산 관리
export const getTeamBudget = ({ year, dptUuid }) => {
  return client.get(`${budgetUrl}/team/info/${dptUuid}/${year}`);
};

export const saveTeamBudget = (dataToSubmit) => {
  return client.post(`${budgetUrl}/team/info`, dataToSubmit);
};

export const deleteTeamBudget = (delData) => {
  return client.delete(`${budgetUrl}/team/info/${delData?.smallId}`);
};

export const uploadExlByTeamBudget = (formData) => {
  return client.post(`${budgetUrl}/team/info/upload`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

export const downloadExlByTeamBudget = ({ year }) => {
  return client.get(`${budgetUrl}/team/info/${year}/download `, {
    responseType: 'arraybuffer',
  });
};
